import { getDefaultSlideDatas } from "@natklok/reducers/questionsReducer";
import { useQuestions } from "./useQuestions";

export default function useDefaultSlideDatas() {
  const { data: questionsData } = useQuestions();
  const questions = questionsData || [];

  return getDefaultSlideDatas(questions);
}
